var _path, _path2, _path3, _ellipse;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgExpense(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 18,
    viewBox: "0 0 21 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.76367 5.17921H8.52732",
    stroke: "white",
    strokeWidth: 0.8,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M18.9027 6.23378H16.454C14.7751 6.23378 13.4141 7.51392 13.4141 9.09316C13.4141 10.6724 14.7751 11.9525 16.454 11.9525H18.9027C18.9812 11.9525 19.0203 11.9525 19.0534 11.9505C19.5609 11.9192 19.965 11.5391 19.9983 11.0617C20.0004 11.0306 20.0004 10.9937 20.0004 10.92V7.2663C20.0004 7.19262 20.0004 7.1557 19.9983 7.12457C19.965 6.64728 19.5609 6.2671 19.0534 6.23582C19.0203 6.23378 18.9812 6.23378 18.9027 6.23378Z",
    stroke: "white",
    strokeWidth: 0.8
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M18.8444 6.13229C18.7713 4.34776 18.5354 3.25362 17.775 2.48332C16.6727 1.36667 14.8984 1.36667 11.35 1.36667H8.5273C4.97889 1.36667 3.2047 1.36667 2.10235 2.48332C1 3.59998 1 5.39721 1 8.99167C1 12.5861 1 14.3834 2.10235 15.5C3.2047 16.6167 4.97889 16.6167 8.5273 16.6167H11.35C14.8984 16.6167 16.6727 16.6167 17.775 15.5C18.5354 14.7298 18.7713 13.6356 18.8444 11.851",
    stroke: "white",
    strokeWidth: 0.8
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 16.8154,
    cy: 9.27557,
    rx: 1.00097,
    ry: 1.01396,
    fill: "white"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgExpense);
export default __webpack_public_path__ + "static/media/expense.58fee5d8a634e941e7d319b5a8e4e5f7.svg";
export { ForwardRef as ReactComponent };